import { render, staticRenderFns } from "./DataQuality.vue?vue&type=template&id=6b89abe8&scoped=true&"
import script from "./DataQuality.vue?vue&type=script&lang=ts&"
export * from "./DataQuality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89abe8",
  null
  
)

export default component.exports